import { z } from "zod";

import Callout from "@/components/ui/chat/callout/Callout";

/** Chat catalog definition for Callout. Use in renderer catalog. */
export const ChatCalloutSpec = {
  props: z.object({
    /**
     * Variant: info, tip, warning, important, or recommended_action (next steps; white, lightning).
     * Nullable/optional; defaults to info in UI when omitted.
     */
    type: z
      .enum(["info", "tip", "warning", "important", "recommended_action"])
      .nullable()
      .optional(),
    /** Optional title above the content. */
    title: z.string().nullable().optional(),
    /** Body text (required). */
    content: z.string(),
  }),
  description:
    "Highlighted callout box for tips, warnings, or key info. Optional type: 'info' | 'tip' | 'warning' | 'important' | 'recommended_action' (use recommended_action for recommended next steps; do not use blockquote or markdown quote for those). Optional title; required content.",
  example: {
    type: "info",
    title: "Note",
    content:
      "Figures are based on the selected date range and may exclude articles still being processed.",
  },
} as const;

type CalloutPropsFromSpec = {
  type?: "info" | "tip" | "warning" | "important" | "recommended_action" | null;
  title?: string | null;
  content: string;
};

/**
 * Adapter for json-render defineRegistry: renders Callout from catalog props.
 */
export const ChatCalloutFromProps = ({
  props,
}: {
  props: Record<string, unknown>;
}) => {
  const { type, title, content } = props as CalloutPropsFromSpec;
  return (
    <Callout
      type={type ?? undefined}
      title={title ?? undefined}
      content={content}
    />
  );
};
